import { z } from 'zod';

const promoCodeSchema = z
  .object({
    code: z.string().min(1),
  })
  .required();

type PromoErrors = 'INVALID' | 'EXPIRED' | 'LIMIT_REACHED' | 'USED_ALREADY';

export { promoCodeSchema, type PromoErrors };
